import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  custom_link: {
    fontSize: "14px",
    lineHeight: "20px",
    padding: "9px 45px 21px 54px",
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
});

const Sidebar = (props: any) => {
  const classes = useStyles();
  return (
    <div className="sidebar">
      <div className="custom-scroll white">
        <div className="scroller">
          <ul className="main-navigation">
            <li>
              <Link to="/shop">Shop Management</Link>
              <img
                src="/assets/images/ic-user-mgmt.svg"
                style={{
                  height: "20px",
                  marginLeft: "20px",
                  top: "18px",
                  display: "list-item",
                  position: "absolute",
                }}
                alt="Shop Management"
              />
            </li>
            <li>
              <Link to="/migration">Migration Of Shop</Link>
              <img
                src="/assets/images/ic-dashboard.svg"
                style={{
                  height: "20px",
                  marginLeft: "20px",
                  top: "18px",
                  display: "list-item",
                  position: "absolute",
                }}
                alt="Food Manage"
              />
            </li>
            <li>
              <Link to="/clean">Clean Shop</Link>
              <img
                src="/assets/images/ic-apps.svg"
                style={{
                  height: "20px",
                  marginLeft: "20px",
                  top: "18px",
                  display: "list-item",
                  position: "absolute",
                }}
                alt="Food Manage"
              />
            </li>
            <li>
              <Link to="/sync">Sync Shop</Link>
              <img
                src="/assets/images/tick.svg"
                style={{
                  height: "20px",
                  marginLeft: "20px",
                  top: "18px",
                  display: "list-item",
                  position: "absolute",
                }}
                alt="Food Manage"
              />
            </li>
            <li>
              <Link to="/harddelete">Hard Delete Shop</Link>
              <img
                src="/assets/images/close-icon.svg"
                style={{
                  height: "20px",
                  marginLeft: "20px",
                  top: "18px",
                  display: "list-item",
                  position: "absolute",
                }}
                alt="Food Manage"
              />
            </li>
            <li>
              <Link to="/version">Version Management</Link>
              <img
                src="/assets/images/ic-dashboard.svg"
                style={{
                  height: "20px",
                  marginLeft: "20px",
                  top: "18px",
                  display: "list-item",
                  position: "absolute",
                }}
                alt="Version Management"
              />
            </li>
          </ul>
        </div>
      </div>
      <div className="btn-logout">
        <a
          href="/"
          onClick={() => {
            localStorage.removeItem("token");
            props.history.push("/login");
          }}
          title="Logout"
        >
          Logout
        </a>
      </div>
    </div>
  );
};
export default Sidebar;
